import { apiClientWithMiddleware } from '../utils/API';
const DEMOGRAPHICS_PATH = 'demographics/v1/portal';
const PLPO_PROGRESS_PATH = 'contextual-onboarding-partner/v1/onboarding-plan/progress';
export const fetchPLPOEligibility = async portalId => {
  const response = await apiClientWithMiddleware().get(DEMOGRAPHICS_PATH, {
    query: {
      portalId
    }
  });
  const isEligible = (response === null || response === void 0 ? void 0 : response.isPlPoEnrolled) || false;
  return isEligible;
};
export const fetchPLPOProgress = async portalId => {
  const response = await apiClientWithMiddleware().get(PLPO_PROGRESS_PATH, {
    query: {
      portalId
    }
  });
  const selectedGroupKey = response.selectedGroupKey;
  const findGroupWithinGroupProgresses = response.groupProgresses.find(group => group.groupKey === selectedGroupKey);
  const progress = (findGroupWithinGroupProgresses === null || findGroupWithinGroupProgresses === void 0 ? void 0 : findGroupWithinGroupProgresses.percentage) || 0;
  return {
    progress,
    groupKey: selectedGroupKey
  };
};